import { Component } from '@angular/core';
import { MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';
import { SuccessSnackbarDataCy } from './success-snackbar.types';

/**
 *
 *
 * @export
 * @class SuccessSnackbarComponent
 */
@Component({
    selector: 'success-snackbar',
    templateUrl: './success-snackbar.component.html',
    styleUrls: ['./success-snackbar.component.scss']
})
export class SuccessSnackbarComponent {
    message: string;
    action: string;
    /**
     *
     *
     * @type {MatSnackBarRef<SuccessSnackbarComponent>}
     * @memberOf SuccessSnackbarComponent
     */
    snackBarRef: MatSnackBarRef<SuccessSnackbarComponent>;

    public successSnackbarDataCy = SuccessSnackbarDataCy;

    get hasAction(): boolean {
        return !!this.action;
    }

    dismiss(): void {
        this.snackBarRef.dismiss();
    }
}
